import { render, staticRenderFns } from "./MotorMthlyStats.vue?vue&type=template&id=0b97960f&"
import script from "./MotorMthlyStats.vue?vue&type=script&lang=js&"
export * from "./MotorMthlyStats.vue?vue&type=script&lang=js&"
import style0 from "./MotorMthlyStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorMthlyStats.vue"
export default component.exports